export default {
  users (state) {
    return state.users
  },
  last_page (state) {
    return state.last_page
  },
  total (state) {
    return state.total
  },
  organizations (state) {
    return state.organizations
  },
  getTrashUser (state) {
    return state.trash.users
  },
  getTrashTotal (state) {
    return state.trash.total
  },
  getTrashLastPage (state) {
    return state.trash.last_page
  },
  getTrashResult (state) {
    return state.trash.result
  },
  getUserOnline (state) {
    return state.user_online
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user/getters.js